module.exports = __webpack_public_path__ + "static/media/usermatrix.6b0b9b04.png";